import React from 'react'
import './PrivacyPolicy.css'

const PrivacyPolicy = () => {
    return (
        <div className='privacy__policy'>
            <div className='privacy__policy__s1'>
                <h1>Privacy Policy</h1>
                <p> <i> Last Updated: January 11, 2026 </i> </p>
            </div>
            <div className='privacy__policy__s2'>
                <p>At Boltcrew Engineering, we value the trust you place in us when sharing your information. This Privacy Policy outlines how we collect, use, and protect your data when you visit our website and engage with our mechanical and electrical engineering services.</p>
            </div>
            <div className='privacy__policy__s3'>
                <div className='privacy__policy__s3__sub'>
                    <h2>1. Information We Collect</h2>
                    <p>We collect information that helps us provide you with high-quality engineering solutions. This includes:</p>
                    <ul>
                        <li>Contact Information: Name, company name, email address, and phone number provided via our inquiry forms.</li>
                        <li>Project Details: Technical information or service requirements you share regarding your mechanical or electrical systems.	</li>
                        <li>Usage Data: Non-identifiable data such as IP addresses and browser types to improve our website’s functionality.</li>
                    </ul>
                </div>
                <div className='privacy__policy__s3__sub'>
                    <h2>2. How We Use Your Information</h2>
                    <p>We use the data we collect to:</p>
                    <ul>
                        <li>Respond to your requests for quotes or site audits.</li>
                        <li>Manage maintenance schedules and spare part deliveries.	</li>
                        <li>Provide technical updates and information regarding our services.</li>
                        <li>Ensure the security and optimization of our website.</li>
                    </ul>
                </div>
                <div className='privacy__policy__s3__sub'>
                    <h2>3. Data Protection & Sharing</h2>
                    <ul>
                        <li>Security: We implement industry-standard security measures to protect your data from unauthorized access or disclosure.</li>
                        <li>Third Parties: We <b>do not</b> sell your data. We only share information with trusted partners (such as logistics providers for spare parts) necessary to complete your service.</li>
                        <li>Legal Compliance: We may disclose information if required by law or to protect the safety and rights of Boltcrew Engineering and our clients.</li>
                    </ul>
                </div>
                <div className='privacy__policy__s3__sub'>
                    <h2>4. Cookies</h2>
                    <p>Our website may use cookies to enhance user experience. You can choose to disable cookies through your browser settings, though some features of the site may be affected.</p>
                </div>
                <div className='privacy__policy__s3__sub'>
                    <h2>5. Your Rights</h2>
                    <p>You have the right to request access to the personal information we hold about you, request corrections, or ask for your data to be deleted from our marketing records.</p>
                </div>
                <div className='privacy__policy__s3__sub'>
                    <h2>6. Contact Us</h2>
                    <p>If you have any questions regarding this Privacy Policy or how your data is handled, please contact us at sales@boltcreweng.com</p>
                </div>
            </div>
        </div>
    )
}

export default PrivacyPolicy